import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useContext } from 'react';
import { ScreenSizeContext } from '../../Measured';
import { useHeroImage } from './useHeroImage';
/**
 *  Important!
 *
 *  - make sure you provide sane defaults
 *  - once built you need to check what the LCP element of the page is, if its the hero
 *    and you are using it for a css background, makes sure you add a hidden image in
 *    the DOM like <img src={hero.src} alt="" width="0" height="0" style={{ display: 'none' }} />
 *    this will allow it to be preloaded by the browser.
 *  - make sure to test perf and LCP
 *  - use the isViewportWidth flag if the hero is fullwidth or close to fullwidth
 *  - watch out for frist visit perf, where we don't know the screensize, you might get double the
 *    images loaded, defaults can help here.
 *
 *  Read useHeroImage comments too.
 *
 *  Sends useHeroImage container dimensions based on passed-in ref
 *  and useHeroImage sends back the appropriate deviation hero Image
 *  for that size.
 * */ export const useHeroImageForContainer = (deviation, container, defaults)=>{
    var _device, _defaults, _defaults1, _device1, _defaults2, _defaults3, _defaults4;
    const { width: screenWidth } = useContext(ScreenSizeContext);
    const isMobile = useContext(MobileContext);
    const { device } = useContext(SessionContext);
    const width = isMobile && !((_device = device) === null || _device === void 0 ? void 0 : _device.isTablet) ? (_defaults = defaults) === null || _defaults === void 0 ? void 0 : _defaults.mobileWidth : (_defaults1 = defaults) === null || _defaults1 === void 0 ? void 0 : _defaults1.width;
    const height = isMobile && !((_device1 = device) === null || _device1 === void 0 ? void 0 : _device1.isTablet) ? (_defaults2 = defaults) === null || _defaults2 === void 0 ? void 0 : _defaults2.mobileHeight : (_defaults3 = defaults) === null || _defaults3 === void 0 ? void 0 : _defaults3.height;
    let containerWidth = container.current ? container.current.clientWidth : width !== null && width !== void 0 ? width : 0;
    if (((_defaults4 = defaults) === null || _defaults4 === void 0 ? void 0 : _defaults4.isViewportWidth) && !container.current) {
        containerWidth = screenWidth;
    }
    return useHeroImage(deviation, containerWidth, container.current ? container.current.clientHeight : height !== null && height !== void 0 ? height : 0);
};
